import { useAuth } from "@/hooks/store/useAuth";
import { Button } from "@/components/Base/Button";
import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useIsUnverified } from "@/hooks/useIsUnverified";
import { RegistrationSuccess } from "@/components/Auth/RegistrationSuccess";

const VerifyPage = () => {
  useIsUnverified();

  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode");
  const [submitting, setSubmitting] = useState(false);
  const { verifyEmail, status, sendVerificationEmail } = useAuth();

  useEffect(() => {
    if (!oobCode || status !== "idle") {
      return;
    }
    verifyEmail(oobCode);
  }, [oobCode, status, verifyEmail]);

  const handleVerify = () => {
    setSubmitting(true);
    sendVerificationEmail();
  };

  return (
    <div className="m-auto flex max-w-screen-sm flex-col gap-4 bg-slate-900 text-slate-100">
      <div>
        {status === "verifying" && "Verifying your email..."}
        {status === "success" &&
          "Email verified! You can now use your account."}
        {status === "error" &&
          "This link is invalid or expired. You can request a new link below."}
        {status === "idle" && <RegistrationSuccess />}
      </div>
      {status === "error" ||
        (status === "idle" && (
          <div className="flex justify-center">
            <Button
              onClick={handleVerify}
              variant={"accent"}
              disabled={submitting}
            >
              Send Verification Email
            </Button>
          </div>
        ))}

      {status === "success" && (
        <div className="flex justify-center">
          <Link to={"/dashboard"}>
            <Button variant={"accent"}>Go To Dashboard</Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default VerifyPage;
